import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { Modal } from '@liveauctioneers/hammer-ui-core/modal';
import {
    CloseButton,
    ModalActions,
    ModalContent,
    ModalHeader,
    ModalTitle,
} from '@liveauctioneers/hammer-ui-core/modal/components';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

export type TwoStepAuthenticationDeactivationModalProps = {
    onCancel: () => void;
    onDeactivate: () => void;
    show: boolean;
};

const TwoStepAuthenticationDeactivationModal = ({
    onCancel,
    onDeactivate,
    show,
}: TwoStepAuthenticationDeactivationModalProps) => {
    const { formatMessage } = useIntl();

    return (
        <Modal
            data-testid="TwoStepAuthenticationDeactivationModal"
            handleClose={onCancel}
            show={show}
            type="composable"
        >
            <CloseButton />
            <ModalHeader>
                <ModalTitle>
                    {formatMessage({
                        id: 'accountSettings.security.twoStepAuthentication.deactivationModal.header',
                    })}
                </ModalTitle>
            </ModalHeader>
            <ModalContent>
                <BodyPrimary className="text-center">
                    {formatMessage({
                        id: 'accountSettings.security.twoStepAuthentication.deactivationModal.description',
                    })}
                </BodyPrimary>
            </ModalContent>
            <ModalActions>
                <div className="flex flex-col items-center gap-xs">
                    <Button
                        className="w-full"
                        onClick={onDeactivate}
                        style="critical"
                    >
                        {formatMessage({
                            id: 'accountSettings.security.twoStepAuthentication.deactivationModal.deactivate',
                        })}
                    </Button>
                    <Button
                        className="w-full"
                        onClick={onCancel}
                        variant="outlined"
                    >
                        {formatMessage({
                            id: 'accountSettings.security.twoStepAuthentication.deactivationModal.keepActivated',
                        })}
                    </Button>
                </div>
            </ModalActions>
        </Modal>
    );
};

export default TwoStepAuthenticationDeactivationModal;
